import { render, staticRenderFns } from "./EditAdresse.vue?vue&type=template&id=8a31da84&"
import script from "./EditAdresse.vue?vue&type=script&lang=ts&"
export * from "./EditAdresse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports